<button bsDatepicker #datePicker="bsDatepicker" type="button" class="btn btn-sm btn-link text-decoration-none text-secondary p-0" [class.inline-edit-value]="!disabled" [(bsValue)]="valueDate" [disabled]="disabled" container="body">
	<fa-icon *ngIf="!disabled" class="me-1" [icon]="faCalendar"></fa-icon> {{ valueDate | date:format }}
</button>
